module.exports = __webpack_public_path__ + "static/media/customDesignStep3Desktop.8e82c65e.PNG";